
import OrderDialog from '~/components/member/order-dialog/index';
import glhFooter from '~/components/public/glh-footer';
import glhHeader from '~/components/public/glh-header';
import Login from '~/components/public/login/index';
import bindPhoneMixin from '~/mixins/bind-phone.js';

export default {
  components: {
    glhFooter,
    glhHeader,
    Login,
    OrderDialog,
  },
  mixins: [bindPhoneMixin],
  data() {
    return {
      screenWidth: 0,
    };
  },
  mounted() {
    const self = this;
    self.screenWidth = document.body.clientWidth;

    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        self.screenWidth = window.screenWidth;
      })();
    };
  },
};
